



















































































import {Component, Prop, Vue} from 'vue-property-decorator'
import {max} from 'lodash'
import IFire from '@/components/icons/IFire.vue'
import ErrorFetchingData from "@/components/lfs/NewStatistics/GeneralDashboard/common/ErrorFetchingData.vue";

@Component({
  name: 'ContactsInterest',
  components: {ErrorFetchingData, IFire}
})

export default class ContactsInterest extends Vue {
  @Prop({ type: String, default: 'Заголовок'  }) protected title!: any
  @Prop({ type: Number, default: 0}) protected none!: any
  @Prop({ type: Number, default: 0}) protected cold!: any
  @Prop({ type: Number, default: 0}) protected warm!: any
  @Prop({ type: Number, default: 0}) protected hot!: any
  @Prop({ type: Boolean, default: false}) protected loading!: any
  @Prop({ type: Boolean, default: false}) protected error!: any
  @Prop({ type: Boolean, default: false}) protected isPdf!: any

  get percent() {
    return max([this.none, this.cold, this.warm, this.hot]) / 100
  }

  calculateWidth(width: number) {
    if (!this.none && !this.cold && !this.warm && !this.hot) return '2px'
    return width / this.percent + '%'
  }
}
